<template>
    <Multiselect
        v-model="value"
        :mode="mode"
        :options="options"
        :searchable="true"
        @update:modelValue="handleInput"
    />
</template>

<script setup>
import { ref } from "vue";
import Multiselect from "@vueform/multiselect";

const props = defineProps({
    context: Object,
});

const mode = props.context.mode || "single";

const initial_value =
    typeof props.context.valueCallback === "function"
        ? props.context.valueCallback(props.context.value)
        : props.context.value;

const value = ref(initial_value || []);

const initial_options =
    typeof props.context.optionsCallback === "function"
        ? await props.context.optionsCallback()
        : props.context.options;

const options = ref(initial_options || []);

function handleInput(modelData) {
    props.context.node.input(modelData);
}
</script>

<style lang="scss">
.multiselect {
    margin-bottom: var(--spacing);
}
.multiselect-search {
    height: 100% !important;
}

.multiselect-clear {
    background: none;
    border: none;
}

.multiselect-tags-search {
    height: auto !important;
    border: none !important;
    margin: 0 !important;
    padding: 0 !important;
    box-shadow: none !important;
}
@import "@vueform/multiselect/themes/default.css";
</style>
